
export class MaskManager {

    public static readonly CPF = {mask: [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]};

    public static readonly DDD = {mask: [/[1-9]/, /\d/]};

    public static readonly telefone = {mask: [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]};

    public static readonly DDDtelefone = {mask: ['(', /[1-9]/, /\d/, ')', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]};

    public static readonly CEP = {mask: [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]};

    public static readonly DATA = {mask: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]};

    public static readonly CNPJ = {mask: [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]};

     public static tel(event: KeyboardEvent) {

      const input: HTMLInputElement = <HTMLInputElement>event.target;
      let v: string = input.value;

      if (!event.key.match(/[0-9]/g) && event.keyCode !== 8) {
        event.preventDefault();
      } else {

        if (event.keyCode === 8) {
          v = v.substr(0, v.length - 1);
        }

        v = v.replace(/\D/g, '') + (event.keyCode !== 8 ? event.key : '');

        if (v.length > 9) {
            event.preventDefault();
        } else {
          v = v.replace(/^(9)?(\d{4})(\d{4})$/g, '$1$2-$3'); // Coloca hifen
          if (event.keyCode !== 8) {
            input.value = v.substr(0, v.length - 1);
          } else {
            input.value = v;
            event.preventDefault();
          }
        }
      }
    }

    static telMask(telefone) {
      let telFormat = '';
      if (telefone) {
        telFormat = telefone.toString().replace(/^(9)?(\d{4})(\d{4})$/g, '$1$2-$3');
      }
      return telFormat;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/mask-manager.ts